<template>
    <div>
        <b-modal id="bookmaker-add" title="Add a new bookmaker" :hide-footer="hideFooter">
            <form action="#" method="POST" class="createBookmaker">
                <div class="form-group">
                    <label for="#bkmName">Bookmaker Name:</label>
                    <input class="form-control" type="text" id="bkmName" placeholder="Ex: Bet365" required="required" v-model="bookmakerName">
                </div>
                <div class="form-group">
                    <label for="#bkmCode">Bookmaker Code:</label>
                    <input class="form-control" type="text" id="bkmCode" placeholder="Ex: 1" required v-model="bookmakerCode">
                </div>
                <div class="form-group">
                    <label for="#bkmDescription">Bookmaker Description:</label>
                    <textarea class="form-control" id="bkmDescription" v-model="bookmakerDescription"></textarea>
                </div>
                <div class="form-group">
                    <label for="#bkmRestrictedCountries">Restricted Countries:</label>
                    <textarea class="form-control" id="bkmRestrictedCountries" v-model="restrictedCountries"></textarea>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-secondary form-control" @click.prevent="saveNewBookmaker">Save</button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { Bus } from '@/main'
import collect from 'collect.js'
export default {
  methods: {
    saveNewBookmaker () {
      if (this.bookmakerDescription && this.bookmakerCode && this.bookmakerName) {
        this.$http.post(`${this.$api_url}/bookmakers/create`, { name: this.bookmakerName, code: this.bookmakerCode, description: this.bookmakerDescription, restricted_countries: this.restrictedCountries }).then((success, error) => {
          if (success) {
            Bus.$emit('reloadBookmakers', success.data)
            this.$bvModal.hide('bookmaker-add')
            this.bookmakerDescription = ''
            this.bookmakerName = ''
            this.bookmakerCode = ''
            this.restrictedCountries = ''
          }
          if (error) {
            this.$bvModal.hide('bookmker-add')
            alert('Duplicate bookmaker size')
          }
        })
      }
    },
    getMaxBookmakerCode () {
      this.$http.get(`${this.$api_url}/bookmakers/all`).then((bookmakers) => {
        if (bookmakers) {
          bookmakers = bookmakers.data
          let maxCode = collect(bookmakers).max('code') || 0
          maxCode = maxCode === '-Infinity' ? 0 : maxCode
          this.bookmakerCode = maxCode + 1
        } else {
          this.bookmakerCode = 1
        }
      })
    }
  },
  data () {
    return {
      bookmakerName: '',
      bookmakerCode: '',
      bookmakerDescription: '',
      restrictedCountries: '',
      hideFooter: true
    }
  },
  created () {
    Bus.$on('modalBookmakersOpened', () => {
      this.getMaxBookmakerCode()
    })
  },
  beforeDestroy () {
    Bus.$off('modalBookmakersOpened')
  }
}
</script>
<style scoped>

</style>
